import React from 'react';

interface IconProps {
  className?: string;
}

interface IconBoxProps {
  icon: React.ComponentType<IconProps>;
  size?: 'small' | 'medium' | 'large';
  className?: string;
}

const IconBox: React.FC<IconBoxProps> = ({
  icon: Icon,
  size = 'medium',
  className = '',
}) => {
  const sizeClasses = {
    small: 'w-16 h-16',
    medium: 'w-24 h-24',
    large: 'w-32 h-32',
    xlarge: 'w-48 h-48',
  };

  return (
    <div
      className={`p-2 border border-white rounded flex items-center justify-center overflow-hidden ${sizeClasses[size]} ${className}`}
    >
      <Icon className='w-full h-full max-w-full max-h-full fill-white' />
    </div>
  );
};

export default IconBox;
